import * as React from "react";
import { TextField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /listings/{listingId}/applications (aussi utilisé par l'onglet
// « Candidatures » de la fiche annonce via ReferenceManyField target=listingId).
export default {
  list: subResourceList({
    parentParam: "listingId",
    parentLabel: "ID annonce",
    children: [
      <TextField key="applicantName" source="applicantName" label="Candidat" />,
      <TextField key="applicantId" source="applicantId" label="ID candidat" />,
      <TextField key="status" source="status" label="Statut" />,
      <TextField key="message" source="message" label="Message" />,
      <FrDateField key="createdAt" source="createdAt" label="Candidaté le" showTime />,
    ],
  }),
};
